import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'
import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1.4rem;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
`

export const CustomSelect = styled(SelectMui)`
  margin: 0 !important;
  height: 2.5rem !important;
`

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const CustomButton = styled(ButtonMui)`
  width: 9rem;
`
